<p-dialog header="Add Fundraiser"
          [modal]="true"
          [(visible)]="visible"
          (onHide)="onDialogClose()"
          [maximizable]="true"
          styleClass="p-dialog-static p-dialog-md fadeinright animation-duration-300">

  <!-- Header -->
  <ng-template pTemplate="header">
    <div class="modal-header">
      <span class="h3 mb-0 white-space-nowrap">Add Fundraiser</span>
    </div>
  </ng-template>

  <!-- Content -->
  <p-card>
    <form [formGroup]="fundraiserForm" (ngSubmit)="saveFundraiser()">
      <p-toast />
      <div class="formgrid grid">

        <!-- First Name -->
        <div class="field col-12 sm:col-6">
          <label for="firstName" class="field-label required">First Name</label>
          <input id="firstName" type="text" pInputText formControlName="firstName" />
          <small *ngIf="fundraiserForm.get('firstName')?.invalid && fundraiserForm.get('firstName')?.touched" class="error">
            First Name is required and must be at least 2 characters long.
          </small>
        </div>

        <!-- Last Name -->
        <div class="field col-12 sm:col-6">
          <label for="lastName" class="field-label required">Last Name</label>
          <input id="lastName" type="text" pInputText formControlName="lastName" />
          <small *ngIf="fundraiserForm.get('lastName')?.invalid && fundraiserForm.get('lastName')?.touched" class="error">
            Last Name is required and must be at least 2 characters long.
          </small>
        </div>

        <!-- Bunder ID -->
        <div class="field col-12 sm:col-6">
          <label for="email">Bundler ID</label>
          <input id="email" type="text" pInputText formControlName="trackingNumber" />
          <small *ngIf="fundraiserForm.get('trackingNumber')?.invalid && fundraiserForm.get('trackingNumber')?.touched" class="error">

          </small>
        </div>

        <!-- Email -->
        <div class="field col-12 sm:col-6">
          <label for="email">Email</label>
          <input id="email" type="email" pInputText formControlName="email" />
          <small *ngIf="fundraiserForm.get('email')?.invalid && fundraiserForm.get('email')?.touched" class="error">
            A valid email is required.
          </small>
        </div>

        <!-- Phone -->
        <div class="field col-12 sm:col-6">
          <label for="phone">Phone</label>
          <input id="phone" type="text" pInputText formControlName="phone" />
          <small *ngIf="fundraiserForm.get('phone')?.invalid && fundraiserForm.get('phone')?.touched" class="error">
            Phone number must be 10 digits.
          </small>
        </div>

        <!-- Address 1 -->
        <div class="field col-12 sm:col-6">
          <label for="address1">Address 1</label>
          <input id="address1" type="text" pInputText formControlName="address1" />
        </div>

        <!-- Address 2 -->
        <div class="field col-12 sm:col-6">
          <label for="address2">Address 2</label>
          <input id="address2" type="text" pInputText formControlName="address2" />
        </div>

        <!-- City -->
        <div class="field col-12 sm:col-6">
          <label for="city">City</label>
          <input id="city" type="text" pInputText formControlName="city" />
          <small *ngIf="fundraiserForm.get('city')?.invalid && fundraiserForm.get('city')?.touched" class="error">
            City is required.
          </small>
        </div>

        <!-- State -->
        <div class="field col-12 sm:col-6">
          <label for="state">State</label>
          <p-dropdown id="state" [options]="states" formControlName="stateId" placeholder="Select a state"></p-dropdown>
          <small *ngIf="fundraiserForm.get('stateId')?.invalid && fundraiserForm.get('stateId')?.touched" class="error">
            State is required.
          </small>
        </div>

        <!-- Zip Code -->
        <div class="field col-12 sm:col-6">
          <label for="zipCode">Zip Code</label>
          <input id="zipCode" type="text" pInputText formControlName="zipCode" />
          <small *ngIf="fundraiserForm.get('zipCode')?.invalid && fundraiserForm.get('zipCode')?.touched" class="error">
            Zip Code must be 5 digits.
          </small>
        </div>

        <!-- Goal -->
        <div class="field col-12 sm:col-6">
          <label for="goal">Goal</label>
          <input id="goal" type="text" pInputText formControlName="goal" />
          <small *ngIf="fundraiserForm.get('goal')?.invalid && fundraiserForm.get('goal')?.touched" class="error">
            Goal must be a valid number.
          </small>
        </div>

        <!-- Parent Bundler ID -->
        <div class="field col-12 sm:col-6">
          <label for="parentBundlerId">Parent Bundler ID</label>
          <input id="parentBundlerId" type="text" pInputText formControlName="parentTrackingId" />
        </div>

      </div>
    </form>
  </p-card>

  <!-- Footer -->
  <ng-template pTemplate="footer">
    <button type="button" pButton label="Cancel" (click)="onCancel.emit()" class="p-button-text"></button>
    <button type="button" pButton label="Save" (click)="saveFundraiser()" [disabled]="fundraiserForm.invalid"></button>
  </ng-template>

</p-dialog>
